// Intl.Locale uses ISO 8601 day numbering: 1=Monday, 7=Sunday.
// This converts to JS getDay() numbering: 0=Sunday, 1=Monday.
function isoFirstDayToJsDay(isoDay) {
  return isoDay === 7 ? 0 : isoDay;
}
export function getFirstDayOfWeek(locale) {
  try {
    var _intlLocale$getWeekIn;
    const intlLocale = new Intl.Locale(locale);
    const weekInfo = (_intlLocale$getWeekIn = intlLocale.getWeekInfo) === null || _intlLocale$getWeekIn === void 0 ? void 0 : _intlLocale$getWeekIn.call(intlLocale);
    if ((weekInfo === null || weekInfo === void 0 ? void 0 : weekInfo.firstDay) !== undefined) {
      return isoFirstDayToJsDay(weekInfo.firstDay);
    }
  } catch (_unused) {
    // invalid locale string
  }
  return 0;
}